
import { CoreFormatCoupon } from '@tencent/wphk-act-base-framework';
import { CouponType } from '@tencent/wphk-act-base-types';

const PRIZE_IMAGE_CDN_BASE = 'https://st.moneydata.hk/res/uploadcdn-static/hkwallet/general/20260818201248';

/**
 * 奖品批次 → 切图映射 (硬编码)
 *
 * 说明：
 * - 因为奖品使用切图展示，需要根据接口返回的 prizeId (batchId) 映射到对应图片
 * - prizeId 由营销平台配置，需与运营确认后填入
 * - 如果 prizeId 未匹配到，使用 fallback 默认图片
 */
export const PRIZE_BATCH_IMAGE_MAP: Record<string, string> = {
  CP4810202608045159: `${PRIZE_IMAGE_CDN_BASE}/668-dialog.png`,
  CP4810202608046763: `${PRIZE_IMAGE_CDN_BASE}/88-dialog.png`,
  CP4810202608047885: `${PRIZE_IMAGE_CDN_BASE}/8-dialog.png`,
  CP4810202608047951: `${PRIZE_IMAGE_CDN_BASE}/1-dialog.png`,
  CP4810202608040827: `${PRIZE_IMAGE_CDN_BASE}/0-5dialog.png`,
  SC001772026081881201: `${PRIZE_IMAGE_CDN_BASE}/2-dialog.png`,
};

const PRIZE_FALLBACK_IMAGE = `${PRIZE_IMAGE_CDN_BASE}/2-dialog.png`;

/**
 * 根据 prizeId 获取奖品图片
 * @param prizeId 接口返回的奖品批次 ID
 * @returns 对应的奖品切图 URL
 */
export const getPrizeImageByBatch = (prizeId: string): string => PRIZE_BATCH_IMAGE_MAP[prizeId] || PRIZE_FALLBACK_IMAGE;

export const isDisplayCoupon = (couponType?: CouponType): boolean => CoreFormatCoupon.isSpType(couponType);
